import { ComponentStyleConfig } from '@chakra-ui/react';

const Modal: ComponentStyleConfig = {
   defaultProps: {
      size: '2xl',
   },
};

export default Modal;
